import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Employee } from "../shared/employee";

@Injectable({
  providedIn: 'root'
})

export class LoginService {
  
  public selectedEmployee= new Employee();

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  FetchLogin(employee:Employee) {
    
    // var body = JSON.stringify(employee);
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post('http://localhost:59355/api/Staff/FetchLogin', body, requestOptions).map(x => x.json());
  
    var body = employee;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    headers.set("Access-Control-Allow-Headers","*");
    headers.set("Access-Control-Request-Method","*");

    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Staff/FetchLogin', body, { headers: headers });
  }

  getUserIPLocation(){
    return this.httpClient.get('https://api.ipify.org?format=json');
  }

}
